import React from 'react';
import { Button } from './Button';
export function FinalCta() {
  return <section className="w-full border-b-2 border-brand-blue bg-black text-white" data-id="element-67" data-mp="vf65316ilxma">
      <div className="mx-auto flex min-h-[420px] max-w-7xl flex-col items-center justify-center px-6 py-20 text-center lg:min-h-[480px] lg:px-10 lg:py-28" data-id="element-68" data-mp="vhiufzelra9d">
        <h2 className="max-w-2xl font-display text-5xl uppercase leading-[0.9] sm:text-6xl lg:text-7xl" data-id="element-69" data-mp="15caurazkkb7u">
          Ready to see your numbers move?
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-70" data-mp="1ee1zodmace0n">
          Free 15-minute call. We look at your funnel, your offer, and where the next dollar comes from.
        </p>
        <div className="mt-8" data-id="element-71" data-mp="1o43nd4aq7uf1">
          <Button variant="primary" data-id="element-72" data-mp="1o4wmpk7cvhn5">Book a Call</Button>
        </div>
      </div>
    </section>;
}